module.exports = __webpack_public_path__ + "img/logo_white.335c366b.svg";